import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type {
  ApiRunResourceSetResponse,
  RunResourceSetMarketRequest,
} from '@/features/prequalification/localControl/types'
import type { UseMutationOptions } from '@/types/queries'

export type RunResourceSetMarketVariables = { resourceSetId: string } & RunResourceSetMarketRequest

export function useRunResourceSetMarketMutation(
  options?: UseMutationOptions<ApiRunResourceSetResponse, RunResourceSetMarketVariables>,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: ({ resourceSetId, ...request }: RunResourceSetMarketVariables) =>
      pqClient.runResourceSetMarket(resourceSetId, request),
  })

  return { runResourceSetMarket: mutateAsync, ...mutationResult }
}
